<template>
  <div id="cardCaixasAbertos">
    <q-card-section class="q-pb-sm">
      <div class="row items-center no-wrap">
        <div class="col">
          <div class="text-grey-9" style="font-size: 16px;">
            Caixas Abertos
          </div>
        </div>
      </div>
    </q-card-section>

    <q-card-section class="q-pt-none">
      <q-markup-table dense flat separator="none">
        <tbody>
          <tr
            v-for="caixa in this.caixasAbertos"
            :key="caixa.id"
          >
            <td class="text-left">{{ $formatDate(new Date(caixa.dtmovimento)) }}</td>
            <td class="text-right">
              <router-link :to="`/caixas/${caixa.id}`" style="text-decoration: none; color: black">
                {{ caixa.caixa_nome }}
              </router-link>
            </td>
            <td class="text-right">{{ caixa.func_resp_nome }}</td>
            <td class="text-right">{{ $currency(caixa.total) }}</td>
          </tr>
          <tr v-if="this.caixasAbertos.length === 0">
            <td colspan="4">Não há nenhum caixa aberto!</td>
          </tr>
        </tbody>
      </q-markup-table>
    </q-card-section>
  </div>
</template>

<script>
export default {
  name: "card-caixas-abertos-loterica",
  props: {
    caixasAbertos: Array
  },
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style lang="stylus" scoped>
  #cardCaixasAbertos
    height: 400px;
    overflow: auto;
  </style>
